import * as _ from 'lodash';
import * as Cookies from 'universal-cookie';
import { useEffect, useState } from 'react';
import { ICenterBase } from '@nkr/models/index';
import { centerSelectCustomStyles, CenterSelectWrapper } from './styles';
import { Button, Modal } from 'react-bootstrap';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';
import Select from 'react-select';
import { Utility } from '@nkr/services/utility';

enum Site {
    NKR,
    NLR
}

const siteMap = [
    { site: Site.NKR, domain: `admin.kidneyregistry${__HIGH_LEVEL_DOMAIN__}`, organ: 'Kidney', organType: OrganType.Kidney },
    { site: Site.NLR, domain: `admin.liverregistry${__HIGH_LEVEL_DOMAIN__}`, organ: 'Liver', organType: OrganType.Liver }
];

interface IProps {
    centerId: number,
    centerList: ICenterBase[],
    onClick: () => void
}

interface IState {
    label: string,
    value: number
}

const CenterSelect = (props: IProps) => {
    const { app: { user }, auth: { authInfo, tokenHex } } = useAppHookContext();

    const [impersonatedCenter, setImpersonatedCenter] = useState<IState>({ label: 'Select a center to login', value: 0 });
    const [showPortalSelection, setShowPortalSelection] = useState(false);
    const [selectedCenter, setSelectedCenter] = useState<ICenterBase>(null);

    useEffect(() => {
        let list = props.centerList.filter(x => x.id == props.centerId).map(center => {
            return { label: center.alias, value: center.id };
        });

        if (list.length > 0) {
            setImpersonatedCenter(list[0]);
        }
    }, [props.centerId, props.centerList])

    const handleCenterChange = (e: any) => {
        var selectedCenterId = e.value;

        let center = props.centerList.find(x => x.id == selectedCenterId);

        // if (!center.isLiverParticipant) {
        if (props.centerId == 0) {
            window.open('/center/' + selectedCenterId);
        } else {
            window.location.href = '/center/' + selectedCenterId;
        }

        let newValue = { label: center.alias, value: center.id };

        setImpersonatedCenter(newValue);
        // } else {
        //     setSelectedCenter(center);
        //     setShowPortalSelection(true);
        // }
    };

    const handleShowNotification = () => {
        props.onClick();
    };

    const handlePortal = (site: Site) => {
        let cookies = new Cookies();

        let f = siteMap.find(x => x.site == site);

        if (f) {
            let url = `https://${f.domain}`;

            let newValue = { label: selectedCenter.alias, value: selectedCenter.id };

            setImpersonatedCenter(newValue);

            let cookieDomain = Utility.getRootDomain(url)

            cookies.set('NkrAuth', { token: authInfo.access_token, user: user }, { path: '/', domain: cookieDomain, secure: __ISSECURE__, httpOnly: false, sameSite: 'lax' });
            cookies.set('NkrSession', tokenHex, { path: '/', domain: cookieDomain, secure: __ISSECURE__, httpOnly: false });
            cookies.set('NkrSite', { domain: f.domain, organ: f.organ, organType: f.organType }, { path: '/', domain: cookieDomain, secure: __ISSECURE__, httpOnly: false });

            if (props.centerId == 0) {
                window.open(url + '/center/' + selectedCenter.id);
            } else {
                window.location.href = url + '/center/' + selectedCenter.id;
            }
        }
    };

    const list = props.centerList.filter(x => x.isMemberCenter).map(center => {
        //return { label: center.alias + (center.isLiverParticipant ? ' (K/L)' : ' (K)'), value: center.id };
        return { label: center.alias, value: center.id };
    });

    return (
        <>
            <CenterSelectWrapper isCenter={props.centerId > 0}>
                <Select
                    styles={centerSelectCustomStyles(props.centerId > 0)}
                    value={impersonatedCenter}
                    options={list}
                    placeholder='Select a Center to Login'
                    onChange={handleCenterChange}
                    onFocus={handleShowNotification}
                />
            </CenterSelectWrapper>

            <Modal backdrop='static' show={showPortalSelection} onHide={() => setShowPortalSelection(false)}>
                <Modal.Body>
                    <h4 style={{ textAlign: 'center', marginBottom: 20 }}>Which portal do you want to access for {selectedCenter?.alias}?</h4>

                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                        <Button bsStyle='primary' onClick={() => handlePortal(Site.NKR)}>National Kidney Registry</Button>&nbsp;
                        <Button style={{ backgroundColor: '#E35205', color: '#fff' }} onClick={() => handlePortal(Site.NLR)}>National Liver Registry</Button>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button bsStyle='link' onClick={() => setShowPortalSelection(false)}>Neither, Stay Here</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CenterSelect;